import React, { useState, useEffect, useRef } from 'react'
import { useTheme, useMediaQuery, IconButton, Menu, MenuItem, Typography, Collapse } from '@material-ui/core'
import MenuIcon from '@material-ui/icons/Menu'
import { KeyboardArrowDown, KeyboardArrowRight } from '@material-ui/icons'
import { useDispatch, useSelector } from 'react-redux'
import './style.scss'

const CategoriasCelular = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [anchorEl, setAnchorEl] = useState(null)
  const [fatherCategories, setFatherCategories] = useState([])
  const childrenCategorys = useRef([])
  const [expandedCategories, setExpandedCategories] = useState(new Set())
  const [showCategories, setShowCategories] = useState(false)
  const [showEditoras, setShowEditoras] = useState(false)
  const dispatch = useDispatch()

  const store = useSelector(state => state.livros.categorias)
  const storeEditoras = useSelector(state => state.livros.editoras)
  const storeFiltro = useSelector(state => state.filtros.categoria) || []

  useEffect(() => {
    const auxArray = []
    childrenCategorys.current = []
    store.map(categoria => {
      if ([null, categoria.cat_id].includes(categoria.cat_idcategoriapai)) {
        auxArray.push(categoria)
      }
    })
    store.map(categoria => {
      if (categoria.cat_idcategoriapai) {
        childrenCategorys.current.push(categoria)
      }
    })
    setFatherCategories([...auxArray])
  }, [store])

  const LivrosFiltrarCategorias = (categoriaNome, categoriaId) => {
    const params = [...storeFiltro]
    const index = params.indexOf(categoriaId)

    if (index === -1) params.push(categoriaId)
    else params.splice(index, 1)

    const action = {
      type: 'GET_CATEGORIA',
      categoria: params
    }

    dispatch(action)
  }

  const filtrarEditoras = (editoraNome) => {
    const action = {
      type: 'GET_EDITORA',
      editora: editoraNome
    }

    dispatch(action)
    setAnchorEl(null)
  }

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
    setShowCategories(false)
    setShowEditoras(false)
  }

  const handleClose = () => {
    setAnchorEl(null)
    setShowCategories(false)
    setShowEditoras(false)
    setExpandedCategories(new Set())
  }

  const handleCategoriesClick = () => {
    setShowCategories(true)
    setShowEditoras(false)
  }

  const handleEditorasClick = () => {
    setShowEditoras(true)
    setShowCategories(false)
  }

  const getCategoriasFilho = (categoriaPaiId) => childrenCategorys.current.filter(categoriaFilho => categoriaFilho.cat_idcategoriapai === categoriaPaiId)

  const hasChildren = (categoriaId) => {
    return store.some(cat => cat.cat_idcategoriapai === categoriaId)
  }

  const toggleExpanded = (categoriaId) => {
    setExpandedCategories(prevExpanded => {
      const newExpanded = new Set(prevExpanded)
      if (newExpanded.has(categoriaId)) {
        newExpanded.delete(categoriaId)
      } else {
        newExpanded.add(categoriaId)
      }
      return newExpanded
    })
  }

  if (!isMobile) {
    return null
  }

  return (
    <div style={{ margin: '10px 0' }}>
      <IconButton
        aria-label="menu de categorias"
        aria-controls="menu-categorias"
        aria-haspopup="true"
        onClick={handleClick}
        color="primary"
        className="menu-button"
      >
        <MenuIcon />
      </IconButton>
      <Menu
        id="menu-categorias"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        PaperProps={{
          style: {
            maxHeight: 400,
            width: '80vw'
          }
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left'
        }}
        className='categorias-mobile-menu categorysMenu'
      >
        {!showCategories && !showEditoras ? (
          <div>
            <MenuItem onClick={handleCategoriesClick} className="menu-option">
              <Typography className="menu-option-text">Categorias</Typography>
              <KeyboardArrowRight />
            </MenuItem>
            <MenuItem onClick={handleEditorasClick} className="menu-option">
              <Typography className="menu-option-text">Editoras</Typography>
              <KeyboardArrowRight />
            </MenuItem>
          </div>
        ) : showCategories ? (
          <div className="mobile-categories-container">
            {fatherCategories.map((categoriaPai) => {
              if (!categoriaPai.cat_idcategoriapai) {
                const temFilhos = hasChildren(categoriaPai.cat_id)
                return (
                  <div key={categoriaPai.cat_id}>
                    <MenuItem className="mobile-category-item">
                      <Typography
                        onClick={() => LivrosFiltrarCategorias(categoriaPai.cat_nome, categoriaPai.cat_id)}
                        className="fatherCategoryText"
                      >
                        {categoriaPai.cat_nome}
                      </Typography>
                      {temFilhos && (
                        <IconButton
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation()
                            toggleExpanded(categoriaPai.cat_id)
                          }}
                          className={expandedCategories.has(categoriaPai.cat_id) ? 'expanded' : ''}
                        >
                          <KeyboardArrowDown />
                        </IconButton>
                      )}
                    </MenuItem>
                    <Collapse
                      in={expandedCategories.has(categoriaPai.cat_id)}
                      timeout="auto"
                    >
                      {getCategoriasFilho(categoriaPai.cat_id).map((categoriaFilho) => (
                        <MenuItem
                          key={categoriaFilho.cat_id}
                          className="mobile-category-item subcategory"
                          onClick={() => LivrosFiltrarCategorias(categoriaFilho.cat_nome, categoriaFilho.cat_id)}
                        >
                          <Typography className="subcategoryName">
                            {categoriaFilho.cat_nome}
                          </Typography>
                        </MenuItem>
                      ))}
                    </Collapse>
                  </div>
                )
              }
              return null
            })}
          </div>
        ) : (
          <div className="celular-editoras">
            {storeEditoras && storeEditoras.map((editora, index) => (
              <MenuItem
                key={index}
                className="mobile-category-item"
                onClick={() => filtrarEditoras(editora.nome)}
              >
                <Typography
                  className="fatherCategoryText"
                  style={{ textAlign: 'left', paddingLeft: '20px' }}
                >
                  {editora.nome}
                </Typography>
              </MenuItem>
            ))}
          </div>
        )}
      </Menu>
    </div>
  )
}

export default CategoriasCelular